export default "__VITE_ASSET__Bs$dg7Av__"